<template>
     <div class="">
        <!-- IMPRESION TICKET DE COMPRA -->
        <vue-html2pdf
          :show-layout="false"
          :float-layout="true"
          :enable-download="false"
          :preview-modal="true"
          :paginate-elements-by-height="300"
          :filename="`Ticket de compra-${folio}`"
          :pdf-quality="2"
          :manual-pagination="true"
          :htmlToPdfOptions = "htmlToPdfOptions"
          pdf-format="b6"
          pdf-orientation="portrait"
          pdf-content-width="100%"
          @progress="onProgress($event)"
          @startPagination="startPagination()"
          @hasPaginated="hasPaginated()"
          @hasGenerated="hasGenerated($event)"
          ref="html2Pdf"
        >
        <section slot="pdf-content" style="width: 75mm !important;">
            <div class="container ticket" style="width: 75mm !important">
              <div class="row justify-content-center">
                <div class="mt-2 col-lg-10 text-center line1">
                  <p><b>Vale</b></p>
                </div>
              </div>
              <div class="mt-2 col-lg-10 text-center">
                <p><b>{{ enterprise }}</b></p>
              </div>
              <div class="mt-1 ml-3 bodyLineHeigth line1 detailFront">
                <label>Folio: {{ detalles.folio }}</label>
                <br>
                <label>Codigo: {{ detalles.barcode }}</label>
                <br>
                <label>Cliente: {{ detalles.client_id }}
                <br>
                {{ detalles.fullName }}</label>
              </div>
            </div>
            <div class="row justify-content-center" style="width: 75mm !important;">
              <div class="col-lg-10 text-center">
                <VueBarcode :value="detalles.barcode" format="CODE39"  textPosition="top" :options="barcode_option" height="40" width="1" font-size="8"/>
                <p><b>{{ ultimaVenta.barcode }}</b></p>
              </div>
            </div>
            <div class="row justify-content-center mt-4 bodyPrintAbono line1" style="width: 70mm !important;">
              <div class="col-lg-12">
                <table style="padding: 0px;" class="">
                  <tr class="text-center tableXD">
                    <td style="height: 5px;" colspan="3">Codigo<br />Descripción VALE</td>
                    <!-- <td>Precio</td>
                    <td>Desc</td>
                    <td>Total</td> -->
                  </tr>
                  <tr class="text-right" style="font-size: 7px;" v-if="type === 'ABONO' || type === 'AJUSTE'">
                    <td class="line1 line2" style="font-size: 10px;"><b>{{ ultimaVenta.descripcion }}</b></td>
                    <!-- <td class="line1 line2" style="font-size: 10px;"><b>$ {{ultimaVenta.amount | formatNumberCurrency}}</b></td> -->
                    <!-- <td class="line1 line2" style="font-size: 10px;"><b>{{ultimaVenta.porcentaje_descuento}} %</b></td> -->
                    <td class="line1 line2" style="font-size: 10px;"><b>$ {{ultimaVenta.amount | formatNumberCurrency}}</b></td>
                  </tr>
                  <tr v-else class="text-right" style="font-size: 7px;" v-for="r in ultimaVenta" :key="r.order_id">
                    <td class="line1 line2" style="font-size: 10px;"><b>{{ r.producto }}</b></td>
                    <td class="line1 line2" style="font-size: 10px;"><b>$ {{r.precio | formatNumberCurrency}}</b></td>
                    <td class="line1 line2" style="font-size: 10px;"><b>{{r.porcentaje_descuento}} %</b></td>
                    <td class="line1 line2" style="font-size: 10px;"><b>$ {{r.venta | formatNumberCurrency}}</b></td>
                  </tr>
                  <hr class="mt-3 mb-3">
                  <td colspan="3">RELACIÓN DE USO</td>
                  <hr class="mt-3 mb-3">
                  <tr class="text-right mt-3 mb-5" v-for="(v, index) in ultimaVenta.used" :key="index" style="font-size: 7px;">
                    <td class="line1 line2" style="font-size: 10px;"><b>VENTA <br> FOLIO {{ v.invoice }}</b></td>
                    <td class="line1 line2" style="font-size: 10px;" colspan="3"><b>MONTO $ {{v.amount | formatNumberCurrency}}</b></td>
                  </tr>
                  <hr class="mt-3 mb-3">
                  <tr>
                    <td colspan="2" class="text-right line1" style="font-size: 10px;">
                      TOTAL DE VALE:
                    </td>
                    <td colspan="2" class="text-right line1" style="font-size: 10px;">
                      <b v-if="type === 'ABONO' || type === 'AJUSTE'">$ {{ ultimaVenta.amount | formatNumberCurrency }}</b>
                      <b v-else>$ {{ detalles.amount | formatNumberCurrency }}</b>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2" class="text-right line1" style="font-size: 10px;">
                      TOTAL UTILIZADO:
                    </td>
                    <td colspan="2" class="text-right line1" style="font-size: 10px;">
                      <b>$ {{(detalles.amount_used) | formatNumberCurrency}}</b>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2" class="text-right" style="font-size: 10px;">
                      TOTAL ACTUAL:
                    </td>
                    <td colspan="2" class="text-right" style="font-size: 10px;">
                      <b>$ {{ detalles.disponible | formatNumberCurrency }}</b>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
            <div class="row justify-content-left mt-2 ml-3">
              <p style="color: black; font-weight:900 !important; font-size: 10px !important;">
                Fecha de Creación: {{ detalles.create_at }} <br>
                Ultima Actualización: {{ detalles.update_at }}</p>
            </div>
            <!-- <div class="row justify-content-center mt-2">
              <div class="col-lg-10 text-center footerTicket line1">
                <p>Gracias por su compra</p>
                <p>Teléfonos:</p>
                <p>442 364 6862</p>
                <p>442 212 0485</p>
                <p>442 212 3268</p>
              </div>
            </div> -->
            <div class="row justify-content-center mt-3">
              <!-- <div class="col-lg-10 text-center footerTicket line1">
                <p>Gracias por su compra</p>
                <p>Teléfonos:</p>
                <p>442 364 6862</p>
                <p>442 212 0485</p>
                <p>442 212 3268</p>
              </div> -->
              <div class="col-9 text-center footerTicket line1">
                <small>Teléfonos:</small>
                <div v-for="p in footer.phones" :key="p.phone">
                  <small>{{ p.phone }}</small> <br>
                </div>
              </div>
              <p class="col-8 mt-1" style="font-size: 10px;">{{ this.footer.couponFooter }}</p>
            </div>
          </section>
        </vue-html2pdf>
      </div>
</template>
<script>
import VueHtml2pdf from 'vue-html2pdf'
import { mapGetters } from 'vuex'
import moment from 'moment'
import axiosAdelaService from '@/axios/axiosAdelaService'
import VueBarcode from 'vue-barcode'

export default {
  props: ['folio', 'enterprise', 'print', 'type'],
  components: {
    VueHtml2pdf,
    VueBarcode
  },
  data () {
    return {
      footer: [],
      barcode_option: {
        format: 'EAN13',
        lineColor: '#0aa',
        height: 55
      },
      totalProductos: 0,
      ultimaVenta: [],
      detalles: [],
      ultimaVentaReales: [],
      htmlToPdfOptions: {
        margin: 0,
        // margin: 0,
        // image: {
        //   type: 'jpeg',
        //   quality: 0.98
        // },
        // enableLinks: false,
        html2canvas: {
          scale: 3,
          useCORS: true
        }
        // jsPDF: {
        //   unit: 'mm',
        //   format: 'b10',
        //   orientation: 'portrait'
        // }
      }
    }
  },
  watch: {
    async print () {
      await this.getFooterTicket()
      if (this.type === 'AJUSTE' || this.type === 'ABONO') {
        this.getAbonoDetail(this.folio)
      } else {
        this.getDevolutionDetail(this.folio)
      }
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    }),
    horaActual () {
      return moment.utc().format('HH:mm:ss')
    }
  },
  methods: {
    async getAbonoDetail (invoice) {
      console.log('entro a este pedo', invoice)
      this.ultimaVenta = []
      this.totalProductos = 0
      const request = {
        folio: invoice,
        enterprise_id: this.user.enterprise_id
      }
      console.log(request)
      const response = await axiosAdelaService.post('/getDetailVale', request)
      console.log('getDetailVale', response)
      if (response.status === 200) {
        this.ultimaVenta = response.data.rows
        this.detalles = response.data.rows
        this.ultimaVenta.create_at = moment(this.ultimaVenta.create_at).format('YYYY-MM-DD')
        // this.ultimaVenta.update_at = moment(this.ultimaVenta.update_at).format('YYYY-MM-DD')
        // this.ultimaVenta.generals.date = moment(this.ultimaVenta.generals.date).format('YYYY-MM-DD HH:MM')
        // const abonos = this.ultimaVenta.abonos
        // this.ultimaVentaReales = response.data.reales
        // let totalVenta = 0
        // let descuento = 0
        // this.ultimaVenta.rows.forEach(el => {
        //   totalVenta += el.precio
        //   descuento += el.descuento
        // })
        // this.ultimaVenta.subtotal = this.getFormattedAmount(totalVenta)
        // this.ultimaVenta.descuento = this.getFormattedAmount(descuento)
        // this.ultimaVenta.total = this.getFormattedAmount(totalVenta - descuento)
        // this.ultimaVentaReales.totalCompra = totalVenta
        // // console.log(this.$formatCurrencyToText(totalVenta - descuento))
        // await this.verifyStatusAbono(abonos)
        this.$refs.html2Pdf.generatePdf()
      }
    },
    async getDevolutionDetail (invoice) {
      console.log('entro a este pedo', invoice)
      this.ultimaVenta = []
      this.totalProductos = 0
      const request = {
        folio: invoice,
        id_empresa: this.user.enterprise_id
      }
      console.log(request)
      const response = await axiosAdelaService.post('/getDetailDevolutionTicket', request)
      console.log('getDetailDevolutionTicket', response)
      if (response.status === 200) {
        this.ultimaVenta = response.data.rows
        this.detalles = response.data.detail
        this.detalles.create_at = moment(this.detalles.create_at).format('YYYY-MM-DD')
        // this.detalles.update_at = moment(this.ultimaVenta.update_at).format('YYYY-MM-DD')
        // this.ultimaVenta.generals.date = moment(this.ultimaVenta.generals.date).format('YYYY-MM-DD HH:MM')
        // const abonos = this.ultimaVenta.abonos
        // this.ultimaVentaReales = response.data.reales
        // let totalVenta = 0
        // let descuento = 0
        // this.ultimaVenta.rows.forEach(el => {
        //   totalVenta += el.precio
        //   descuento += el.descuento
        // })
        // this.ultimaVenta.subtotal = this.getFormattedAmount(totalVenta)
        // this.ultimaVenta.descuento = this.getFormattedAmount(descuento)
        // this.ultimaVenta.total = this.getFormattedAmount(totalVenta - descuento)
        // this.ultimaVentaReales.totalCompra = totalVenta
        // // console.log(this.$formatCurrencyToText(totalVenta - descuento))
        // await this.verifyStatusAbono(abonos)
        this.$refs.html2Pdf.generatePdf()
      }
    },
    onProgress (progress) {
      this.progress = progress
      console.log(`PDF generation progress: ${progress}%`)
    },
    startPagination () {
      console.log('PDF has started pagination')
    },
    hasPaginated () {
      console.log('PDF has been paginated')
    },
    async beforeDownload ({ html2pdf, options, pdfContent }) {
      console.log('On Before PDF Generation')
    },
    hasDownloaded (blobPdf) {
      console.log('PDF has downloaded yehey')
      this.pdfDownloaded = true
      console.log(blobPdf)
    },
    getFormattedAmount (amount) {
      if (amount) {
        return '$ ' + this.$formatNumberCurrency(amount, 'MXN')
      } else {
        return ''
      }
    },
    async getFooterTicket () {
      const request = {
        enterprise_id: this.user.enterprise_id
      }
      console.log('getFootero request', request)
      const response = await axiosAdelaService.post('/getFooterTicket', request)
      console.log('verifyStatusAbono XXXDDD', response)
      if (response.status === 200) {
        this.footer = response.data
      }
    },
    async verifyStatusAbono (abonos) {
      const request = {
        abonos: abonos,
        id_empresa: this.user.enterprise_id
      }
      console.log('verifyStatusAbono request', request)
      const response = await axiosAdelaService.post('/verifyStatusAbono', request)
      console.log('verifyStatusAbono XXXDDD', response)
      if (response.status === 200) {
        // this.$refs.html2Pdf.generatePdf()
      }
    }
  }
}
</script>

<style>

.ticketTable td{
  font-size: 7px;
}
.ticketClass {
  width: 8cm;
}
/* .inputNumberClient {
  border-radius: 10px;
  border-color: red;
  text-align: center;
}
.btnAddOrder {
  border: none;
  font-size: 18px;
  border-radius: 10px;
  color: white;
}
.btnAddRow {
  font-size: 30px;
  background: #22da65;
  width: 100px;
}
.btnRegister {
  background: #227bda;
  padding: 5px;
}
.green {
  background:#1580002e;
  color:white;
}
.otherClient {
  background: #00ccfd69;
}
.red {
  background: red;
  color:white;
}
.inputBarCode {
  width: 300px;
  font-size: 20px;
  border-radius: 5px;
  border-color: blue;
  text-align: center;
}
.endRow {
    margin-right: 0%;
}
.greenChange {
  background: rgb(0, 255, 0);
  color:rgb(27, 2, 2);
} */
table, th, td {
  /* font-family: "VollkornRegular";
  src: local("VollkornRegular"),
   url(../../assets/sass/styles/fonts/VollkornRegular.ttf) format("truetype"); */
  /* font-family: Cantarell, Ticketing, Roboto, Cantarell, 'Courier New', Courier, monospace; */
  color: black;
  /* line-height: .1px !important; */
  font-weight: bolder !important;
  /* border: .1rem solid; */
  /* border: .5px solid orange; */
  border-bottom: 1pt solid black;
  border-collapse: collapse;
  font-size: 10px;
}
.footerTicket p {
  line-height: .1px;
}
.bodyLineHeigth {
  font-size: 10px;
}
.bodyLineHeigth td {
  font-size: 10px;
}

.footerTicket p {
  font-size: 8px;
  line-height: .1px !important;
}
.line1 {
  /* font-family: "VollkornRegular";
  src: local("VollkornRegular"),
   url(../../assets/sass/styles/fonts/VollkornRegular.ttf) format("truetype"); */
  /* font-family: Cantarell, Ticketing, Roboto, Cantarell, 'Courier New', Courier, monospace; */
  color: black;
  /* line-height: .1px !important; */
  font-weight: bolder !important;
  font-size: 10px !important;
}
.line2 {
  /* font-size: 8px !important; */
}
.bodyPrintAbono table {
  /* font-family: "VollkornRegular";
  src: local("VollkornRegular"),
   url(../../assets/sass/styles/fonts/VollkornRegular.ttf) format("truetype"); */
  color: black;
  font-size: 8;
  width: 100%;
}

.bodyPrintAbono td, th {
  /* border: 1px solid #dddddd; */
  text-align: left;
  padding: 8px;
}

.bodyPrintAbono tr:nth-child(even) {
  /* background-color: #dddddd; */
}
.ticket {
  /* font-family: "VollkornRegular";
  src: local("VollkornRegular"),
   url(../../assets/sass/styles/fonts/VollkornRegular.ttf) format("truetype"); */
  /* font-family: Cantarell, Ticketing, Roboto, 'Courier New', Courier, monospace; */
  color: black;
  font-size: 10px;
  font-weight: bolder !important;
}
.tableXD {
  font-weight: bolder !important;
  font-size: 10px !important;
}
.detailFront p {
  font-size: 10px;
  line-height: 16.5pt !important;
  margin-bottom: 0px !important;
  margin: 0 !important;
}
.descuentoInpit {
  padding: 0;
}
</style>
